'use client';
import { useSelector } from '@xstate/store/react';
import Link from 'next/link';
import { useEffect, useState } from 'react';

import CartIcon from '@/fo/icons/base/landing/cart.svg';
import EsthedermLogo from '@/fo/icons/base/landing/esthederm-black.svg';
import EsthedermLogoLight from '@/fo/icons/base/landing/esthederm-white.svg';
import NaosLogoLight from '@/fo/icons/base/landing/naos-logo-white.svg';
import NaosLogo from '@/fo/icons/base/landing/naos-logo.svg';
import { storeProduct, selectCounterCart } from '@/fo/store/product';

import { styles } from './UiLandingHeaderEsthederm.styles';

export interface UiLandingHeaderEsthedermProps {
  progressColor?: string;
  /** Белые логотипы, пока хедер прозрачный */
  light?: boolean;
}

export function UiLandingHeaderEsthederm({
  progressColor,
  light = false
}: UiLandingHeaderEsthedermProps) {
  const [isScrolled, setIsScrolled] = useState(false);
  const [progress, setProgress] = useState(0);
  const cartCount = useSelector(storeProduct, selectCounterCart);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 0);
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight;
      const winHeight = window.innerHeight;
      const total = Math.max(docHeight - winHeight, 1);
      setProgress(Math.min(100, Math.max(0, (scrollTop / total) * 100)));
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const slots = styles({ scrolled: isScrolled, light });
  const LogoNaos = light && !isScrolled ? NaosLogoLight : NaosLogo;
  const LogoEsthederm =
    light && !isScrolled ? EsthedermLogoLight : EsthedermLogo;

  return (
    <header className={slots.base()}>
      <Link
        href="/"
        className={slots.logoWr()}
      >
        <LogoNaos
          className={slots.logoNaos({
            className: light && !isScrolled ? 'md:!h-10 md:!w-auto' : undefined
          })}
        />
        <div className={slots.divider()} />
      </Link>
      <Link href="/esthederm">
        <LogoEsthederm
          className={slots.logoEsthederm({
            className:
              light && !isScrolled ? 'md:!h-[76px] md:!w-auto' : undefined
          })}
        />
      </Link>
      <Link
        href="/cart"
        target="_blank"
        className={slots.cart()}
      >
        <CartIcon />
        {cartCount > 0 && (
          <span className={slots.cartCounter()}>{cartCount}</span>
        )}
      </Link>
      <div
        className={slots.progress()}
        style={{ width: `${progress}%`, borderColor: progressColor }}
      />
    </header>
  );
}
